import { Document, View } from '@react-pdf/renderer';
import { CreditNoteContent, PageComponent, SummaryProductTable, UsageLogs } from '../../components';
import { CreditNote } from '../../../credit/interfaces/credit-note-interface';
import { Supplier } from '../../../common';
import { isUsageLogsExist } from '../../utils/usageUtils';
import { styles } from './CreditNotePDF.module';

interface CreditNotePDFProps {
  creditNoteData: CreditNote;
  supplier?: Supplier;
  isPreview?: boolean;
}

export const CreditNotePDF = ({ creditNoteData, supplier, isPreview }: CreditNotePDFProps) => {
  return (
    <Document>
      <PageComponent supplier={supplier} isPreview={isPreview} documentState={creditNoteData?.state}>
        <CreditNoteContent creditNoteData={creditNoteData} supplier={supplier} />
      </PageComponent>

      {creditNoteData?.pricingModel?.tabs.length > 1 && (
        <PageComponent supplier={supplier} isPreview={isPreview} documentState={creditNoteData?.state}>
          <View style={styles.productTablesContainer}>
            {creditNoteData?.pricingModel?.tabs?.map((tab, index) => (
              <SummaryProductTable
                key={index}
                product={tab}
                isPartialPeriod={tab?.isPartialPeriod}
                constantDiscount={0}
              />
            ))}
          </View>
        </PageComponent>
      )}

      {isUsageLogsExist(creditNoteData?.usageReportsByProduct) &&
        creditNoteData.customer?.settings?.attachUsageLogsPdf && (
          <UsageLogs
            isPreview={isPreview}
            usageReportsByProduct={creditNoteData?.usageReportsByProduct}
            poNumber={creditNoteData?.poNumber}
            supplier={supplier}
          />
        )}
    </Document>
  );
};
